export default __webpack_public_path__ + "static/media/pubblication_trend.036bfda5.png";